import { Loader, Skeleton } from '@/components/ui'

// Letter shape while the reader loads, so the box does not jump when the real page lands.
export const OpeningPage = () => (
  <div className="relative aspect-[8.5/11] w-full">
    <Skeleton className="size-full rounded-none" />
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
      <Loader size="md" className="text-neutral-400" />
      <p className="text-xs text-ink-subtle">Opening the page…</p>
    </div>
  </div>
)
